var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C80B",
    d: "M9 2a1.98 1.98 0 0 1-.537 1.362l.84 1.797a4.48 4.48 0 0 1 4.331 1.11L16.06 4.49A2.002 2.002 0 0 1 18 2c1.104-.001 2.001.896 2.001 1.999a2.002 2.002 0 0 1-3.053 1.7l-2.425 1.778A4.47 4.47 0 0 1 15 9.497c0 .578-.11 1.131-.31 1.64l2.104 1.263a2.002 2.002 0 0 1 3.203 1.597c0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.975-2.31l-2.106-1.262a4.5 4.5 0 0 1-7.853-2.175h-2.21A1.999 1.999 0 0 1 0 9.5c0-1.103.897-2 2-2 .84 0 1.56.516 1.853 1.25h2.21a4.502 4.502 0 0 1 1.88-2.953l-.84-1.8C7.07 4 7.034 4 7 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2Zm1.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })));
};
export default SvgNetwork;